export default {
  root: ({ orgConfig }) => ({
    "&.admin-nav-left": {
      "& .ui.menu .item.active, & .ui.menu .item:hover": {
        background: `${orgConfig.theme.primary}26` || "#69BBFB"
      }
    }
  })
};
